/** HK chart identities stay separate from mainland six-digit securities. */
export function hongKongSymbol(input: string): string | null {
  const s=input.trim();
  if (/^(?:hk)?hstech(?:\.hk)?$/i.test(s)) return 'hkHSTECH';
  const m=/^(?:hk)?(\d{4,5})(?:\.hk)?$/i.exec(s);
  return m ? `hk${m[1].padStart(5,'0')}` : null;
}
export const HK_MINUTE_REASON='港股真实分钟行情尚未完成接入与时段、成交量口径核验；不以日线估算替代分钟剖面。';
